import React from 'react';
import * as S from './style';
import { SpaceDiv, Btn } from 'components';
import Label, { Props as LabelProps } from 'components/atoms/Label';
import { ReactComponent as Close } from 'assets/img/common/ic_close.svg';

export interface Props {
    children: React.ReactNode;
    buttons: React.ReactNode;
    isShow: boolean;
    labelProps: LabelProps;
    width?: number;
    noTitle?: boolean;
    onClickPopupAction: () => void;
}

function LayerPopUp({ children, buttons, isShow, onClickPopupAction, ...props }: Props): React.ReactElement {
    return (
        <S.LayerPopUpContainer show={isShow} width={props.width}>
            <S.LayerDim />
            <S.LayerPopUpWrapper>
                <S.CloseWrapper>
                    <Btn onClick={onClickPopupAction} backGroundColor={'transparent'}>
                        <Close />
                    </Btn>
                </S.CloseWrapper>
                <SpaceDiv backgroundColor={'gray_opacity_300'} />
                <S.PopupBodyContiner>
                    {!props.noTitle && (
                        <S.TitleWrapper>
                            <Label {...props.labelProps} />
                        </S.TitleWrapper>
                    )}
                    <S.ChildrenWrapper noTitle={props.noTitle}>{children}</S.ChildrenWrapper>
                    <S.BtnWarpper>{buttons}</S.BtnWarpper>
                </S.PopupBodyContiner>
            </S.LayerPopUpWrapper>
        </S.LayerPopUpContainer>
    );
}

export default LayerPopUp;
